import React from "react";
import styled from "styled-components";

const LogoStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: color #000;
  border: 5px solid #fff;
  border-radius: 50%;
  padding: 10px;
  width: 50px;
  height: 50px;
  font-size: 40px;
  flex: 0.2;
`;

function Logo() {
  return <LogoStyled>H</LogoStyled>;
}

export default Logo;
